var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', {
    staticClass: "youtube"
  }, [_c('iframe', {
    attrs: {
      "src": `https://www.youtube.com/embed/${_vm.id}`,
      "frameborder": "0",
      "allow": "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
      "allowfullscreen": ""
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }